import { getSolicitudCanje } from "@/shared/actions/erp/marketing";
import { getSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";
import { IProspectOmitData, TipoSolicitudesEnum } from "@/shared/interfaces";
import { fieldCanje, fieldEvento } from "@/shared/utils/fields-modal-generic-object";
import { Visibility } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { useMemo } from "react";
import { openGenericObjectModalAsync } from "../ModalGenericObject/useGenericObjectModalStore";

interface TipoVentaCanjeEventoProps {
  prospecto_data: IProspectOmitData
  tipo_venta?: string
}

export default function TipoVentaCanjeEvento({
  prospecto_data,
  tipo_venta = TipoSolicitudesEnum.HOGAR
}: TipoVentaCanjeEventoProps) {


  const handleValidarTipoVenta = useMemo(() => {

    if (prospecto_data.solicitud_canje) {
      return TipoSolicitudesEnum.CANJE
    }
    if (prospecto_data.solicitud_evento) {
      return TipoSolicitudesEnum.EVENTO
    }
    return tipo_venta
  }, [prospecto_data.codigo])

  return (
    <Grid
      container
      justifyContent={'space-between'}
      alignContent={'center'}
      alignItems={'center'}
      spacing={1}
    >

      <Grid item >
        Cliente <b>{handleValidarTipoVenta}</b>
      </Grid>

      {
        [TipoSolicitudesEnum.CANJE,
        TipoSolicitudesEnum.EVENTO,
        TipoSolicitudesEnum.EVENTO_GRATUITO,
        TipoSolicitudesEnum.EVENTO_PAGADO,
        ]
          .includes(handleValidarTipoVenta as TipoSolicitudesEnum) && (
          <Grid item >
            <Button
              startIcon={<Visibility />}
              onClick={() => {

                const solicitud_canje = prospecto_data.solicitud_canje;
                const solicitud_evento = prospecto_data.solicitud_evento;

                openGenericObjectModalAsync({
                  fetcher: async () => {
                    if (solicitud_canje) {
                      const resp = await getSolicitudCanje({
                        codigo: solicitud_canje
                      })
                      return resp.data.data[0]
                    }

                    const resp = await getSolicitudEvento({
                      codigo: solicitud_evento
                    })

                    return resp.data.data[0]
                  },

                  fields: solicitud_canje
                    ? fieldCanje
                    : fieldEvento,
                  title: 'Información',
                })
              }}
            >
              VER INFORMACIÓN
            </Button>
          </Grid>
        )
      }

    </Grid>
  )

}